module.exports = __webpack_public_path__ + "static/media/mickaelold.14fd72ec.jpg";